export default __webpack_public_path__ + "static/media/DIY08.2ea896c6.JPG";